import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class GroupsManagerService {

  constructor(private httpClient: HttpClient, @Inject('apiEndPoint') private apiEndPoint: string) { }

  getAllGroups(params) {
    return this.httpClient.post(this.apiEndPoint + '/gwdevice/devicegroup/_search?size=1000', params);
  }
  getAllTemplates(templateId: any) {
    return this.httpClient.get(this.apiEndPoint + '/gwdevice/band_template/' + templateId);
  }
  getDevicesStatusByRuleId(ruleId: any) {
    return this.httpClient.get(this.apiEndPoint + '/_/2.0/bandlockstatus?ruleid=' + ruleId)
  }
  getGroupDetailsById(groupId: any) {
    return this.httpClient.get(this.apiEndPoint + '/gwdevice/devicegroup/' + groupId);
  }
  getAllNonGroupDevices() {
    return this.httpClient.get(this.apiEndPoint + '/_/2.0/nongrouplist');
  }
  requestStringCreator(arr) {
    let str
    arr && arr.map(each => {
      str ? str = `${str} or (${each})` : str = `(${each})`
    })
    return str
  }
  getAllDevices() {
    return this.httpClient.get(this.apiEndPoint + '/gwdevice/edgedevicemaster_slice/_search?size=1000');
  }
  getAllDevicesWithParams(devices) {
    const queryData = this.requestStringCreator(devices);
    const filter = {
      query: { bool: { must: [{ query_string: { query: queryData, type: "phrase", fields: ["imei"] } }] } },
      sort: { "_kuzzle_info.createdAt": "desc" }
    }
    return this.httpClient.post(this.apiEndPoint + '/gwdevice/edgedevicemaster_slice/_search?size=1000', filter);
  }
  handleAPNSettings(devices, user) {
    return this.httpClient.post(this.apiEndPoint + '/_/2.0/edgecontrol', {
      status: "active", rule: "apnupdate", devices: devices, user_name: user
    });
  }
  checkgroup(groupId: any) {
    //to check if walktest is running in a modem before modifying any group.
    return this.httpClient.post(this.apiEndPoint + '/_/checkgroup', { "groupid": [groupId] });
  }
  getAllBandTemplates() {
    return this.httpClient.get(this.apiEndPoint + '/gwdevice/band_template/_search?size=1000');
  }
  createGroupManager(data) {
    return this.httpClient.post(this.apiEndPoint + '/_/2.0/group_create_modify', data);
  }
  updateGroupManager(data, id) {
    return this.httpClient.post(this.apiEndPoint + `/_/2.0/group_create_modify`, data);

  }
  deleteGroup(id) {
    return this.httpClient.delete(this.apiEndPoint + `/gwdevice/devicegroup/${id}`);
  }
  eventLog(log: any) {
    return this.httpClient.post(this.apiEndPoint + '/gwdevice/eventlog/_create', log)
  }
  bandLock(log: any) {
    return this.httpClient.post(this.apiEndPoint + '/_/2.0/edgecontrol', log)
  }
}

